import NotesAndInsights from '@components/shared/react-table-wrapper/columns/notes-and-insights/NotesAndInsights';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHeapTrack } from '../../../../../hooks/UseHeapTrack';
import { usePortfolioFilter } from '../../../../../hooks/UsePortfolioFilter';
import { AppState } from '../../../../../store/AppState';
import {
  setPortfolioNotesModalOpen,
  setPortfolioNotesModalResource,
  setPrivateIncentiveModalOpen,
  setPrivateIncentiveModalResource,
} from '../../../../../store/portfolio/PortfolioActions';
import { PortfolioState } from '../../../../../store/portfolio/PortfolioReducer';
import { NoteResource } from '../../../../../types/Note';
import { PrivateIncentiveActionType } from '../../../../../types/PrivateIncentiveModalResource';

export type PortfolioNotesAndInsightsProps = {
  dealerId: string;
  inMarket: boolean;
  isConquest: boolean;
  isPrivateIncentiveApplied: boolean;
  isFordPrivateIncentive: boolean;
  hasOpenRecall?: boolean;
  isBalloon: boolean;
  recall?: Array<string>;
  wasMailerSent: boolean;
  closedDealId: string;
  fullName: string;
  vin: string;
  status: string;
  subStatus: string;
  isLeaseBuyout: boolean;
  expireDate: string;
  privateIncentiveAmount: string | null;
  isEvEnabled: boolean;
  lastName: string;
  isCpo?: boolean;
  shopperActivity?: Array<string>;
};

const PortfolioNotesAndInsights: FC<PortfolioNotesAndInsightsProps> = (props) => {
  const dispatch = useDispatch();
  const { getPortfolioView } = usePortfolioFilter();
  const { dealType } = useSelector<AppState, PortfolioState>(
    (portfolioState) => portfolioState.portfolio,
  );
  const notesCount = getPortfolioView(dealType).notesCountMap?.find(
    (x) => x.leadId === props.closedDealId,
  )?.count;
  const storeCode = localStorage.getItem('am.storeCode');

  const handleOpenNotesModal = async (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    var notesResource: NoteResource = {
      dealerId: props.dealerId,
      closedDealId: props.closedDealId,
      fullName: props.fullName,
      vin: props.vin,
      status: props.status,
      subStatus: props.subStatus,
    };
    dispatch(setPortfolioNotesModalResource(notesResource));
    dispatch(setPortfolioNotesModalOpen(true));
  };

  const handleOpenPrivateIncentiveModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (
      props.privateIncentiveAmount != null &&
      props.privateIncentiveAmount != '' &&
      parseInt(props.privateIncentiveAmount) > 0
    ) {
      const privateIncentiveType =
        props.isConquest && props.isPrivateIncentiveApplied
          ? 'Service'
          : props.isPrivateIncentiveApplied
            ? 'Loyalty'
            : '';

      if (privateIncentiveType !== '') {
        useHeapTrack(
          'Automated PIL - ' +
            privateIncentiveType +
            ' Private Incentive Lookup from Loyalty dashboard',
          {
            StoreCode: storeCode,
            DealerId: props.dealerId,
            Vin: props.vin,
            LastName: props.lastName,
          },
        );
      }
      dispatch(
        setPrivateIncentiveModalResource({
          lastName: props.lastName,
          vin: props.vin,
          isLeaseBuyOut: props.isLeaseBuyout,
          leadId: '',
          legacyDealerId: '',
          privateIncentiveLookupActionType: props.isConquest
            ? PrivateIncentiveActionType.PrivateIncentiveLookupLoyaltyDashboardServiceCustomer
            : PrivateIncentiveActionType.PrivateIncentiveLookupLoyaltyDashboardLoyaltyCustomer,
          leadDealerId: '',
        }),
      );
      dispatch(setPrivateIncentiveModalOpen(true));
    } else {
      dispatch(setPrivateIncentiveModalOpen(false));
    }
  };

  return (
    <>
      <NotesAndInsights
        dealerId={props.dealerId}
        isBalloon={props.isBalloon}
        isConquest={props.isConquest}
        isFordPrivateIncentive={props.isFordPrivateIncentive}
        isPrivateIncentiveApplied={props.isPrivateIncentiveApplied}
        hasOpenRecall={props.hasOpenRecall}
        inMarket={props.inMarket}
        recall={props.recall}
        wasMailerSent={props.wasMailerSent}
        closedDealId={props.closedDealId}
        fullName={props.fullName}
        vin={props.vin}
        status={props.status}
        subStatus={props.subStatus}
        isLeaseBuyout={props.isLeaseBuyout}
        handleOpenNotesModal={handleOpenNotesModal}
        handleOpenPrivateIncentiveModal={handleOpenPrivateIncentiveModal}
        notesCount={notesCount}
        expireDate={props.expireDate}
        isEvEnabled={props.isEvEnabled}
        privateIncentiveAmount={props.privateIncentiveAmount}
        isCpo={props.isCpo}
        shopperActivity={props.shopperActivity}
      />
    </>
  );
};

export default PortfolioNotesAndInsights;
